import React from 'react';
import { Box, useColorModeValue } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import DiretoriaComercialSidebar from '../pages/UsersArea/DiretoriaComercial/Sidebar/DiretoriaComercialSidebar';

const DiretoriaComercialLayout = () => {
  const bgMain = useColorModeValue('gray.50', 'gray.900');
  
  return (
    <Box display="flex" minH="100vh">
      <DiretoriaComercialSidebar />
      <Box 
        flex="1" 
        ml={{ base: 0, lg: "250px" }}
        bg={bgMain}
        p={{ base: 4, md: 6, lg: 8 }}
        pt={{ base: 20, lg: 8 }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default DiretoriaComercialLayout;